import './theoaks/style';
import FormStructure from './theoaks/form_structure';

export default FormStructure;